import { Switchbox, SearchFilterPanel } from "@weirgroup/weir-dls";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { FilterType } from "../../../types/filter.type";
import "../styles.scss";
import { useDarkMode } from "../../../hooks/use-darkmode";

interface Props {
  tableToggleOnChange: () => void;
  isTableShown: boolean;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  filterAssets: any;
  filters: FilterType[];
  setFilters: Dispatch<SetStateAction<FilterType[]>>
}

export const Filter = (props: Props) => {
  const {
    tableToggleOnChange,
    isTableShown,
    setSearchQuery,
    filterAssets,
    filters,
    setFilters
  } = props

  const { t } = useTranslation();
  const {darkMode} = useDarkMode()
  
  const onChange = (event: any) => {
    // Now that duplicates have suffixes, title matching should work correctly
    const targetTitle = event;
    
    const updatedFilters = filters.map(filter => ({
      ...filter,
      type: filter.type.map(item => {
        if (item.title === targetTitle) {
          return { ...item, checked: !item.checked };
        }
        return item;
      })
    }));
    
    setFilters(updatedFilters);
  }

  return (
    <div className="filter-wrapper"> {/* Add a wrapper div */}
      <div className="filter-container">
        <div className="filter-row">
          <p style={{color:darkMode ? "white": "black"}}>Map View</p>
          <Switchbox
            darkMode={darkMode}
            name="tester"
            checked={isTableShown}
            label="Table View"
            onChange={tableToggleOnChange}
          />
        </div>
        <div className="filter-panel-container">
          <SearchFilterPanel
            Label={t("assetSearch")}
            darkMode={darkMode}
            ResultSet={filters}
            onSearchChange={(e: any) => setSearchQuery(e)}
            onSearchIconClick={(e: any) => {
              filterAssets()
            }}
            onCheckBoxChange={(e: any) => onChange(e)}
          />
        </div>
      </div>
    </div>
  );
}

